import React from 'react'

import FormattedDateTime from 'syft-acp-core/components/FormattedDateTime'

import { startMsOf, WINDOW_24H_MS } from './helpers'
import { WorkerJobBooking } from './types'

// One selectable shift row: checkbox + date, a "late" badge when within 24h, and
// FC/CH badges ONLY when that shift's booking has them set (so flagged shifts stand out).
export const ShiftRow = ({
  booking,
  checked,
  onToggle,
}: {
  booking: WorkerJobBooking
  checked: boolean
  onToggle: (shiftId: number) => void
}) => {
  const startMs = startMsOf(booking)
  const isLate = startMs - Date.now() < WINDOW_24H_MS

  return (
    <label className="shift-row">
      <span>
        <input type="checkbox" checked={checked} onChange={() => onToggle(booking.shift_id)} />{' '}
        {/* @ts-expect-error legacy component types */}
        <FormattedDateTime
          value={startMs}
          format={{ day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' }}
        />
      </span>
      {isLate && <span className="late-badge">starts in &lt;24h · late</span>}
      {booking.syft_compensation && <span className="flag-badge fc">FC</span>}
      {booking.syft_unpaid_hours_compensation && <span className="flag-badge ch">CH</span>}
    </label>
  )
}
